/** External */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import _ from "lodash";

/** Internal */
import { graphql, compose } from "lib/apolloClient";
import { updateSnpPermissions } from "InternalTools/modules/InternalToolsModules";
import { getInternalToolGenericDataFromCache } from "InternalTools/modules/InternalToolsGraphqlHelper";
import {
  ADD_ON_MANAGER,
  AUTH_AND_EVAL,
  FETCH_CURRICULUM_PROGRAM_WITH_SNP_PERM_STATUS,
} from "InternalTools/modules/InternalToolConstants";
import { getPermissionsPayloadForMutation } from "InternalTools/modules/InternalToolUtils";
import { GRAPHQL_ONGOING_QUERY_NETWORK_STATUS } from "Constants";
import { getInternalToolGenericDataQuery } from "InternalTools/modules/InternalToolsQuery";
import withLoader from "UIComponents/GqlWithLoader";

/** Relative */
import ManageSetsForSnP from "./ManageSetsForSnP";

const ManageAccessForSnP = ({
  closeModal,
  isData,
  isLoading,
  data,
  updateSnpPermissions,
  organizationId,
  curriculumProgramId,
  onSuccessAddOnConfigChange,
  testId,
}) => {
  const [curriculumPrograms, setCurriculumPrograms] = useState([]);

  const localTestId = `${testId}-manageAccessForSnP`;

  useEffect(() => {
    if (isData && !isLoading) {
      const selectedProgram = _.find(
        data,
        program => program.id == curriculumProgramId // using == as for some curriculums id is not string
      );

      if (selectedProgram) {
        setCurriculumPrograms([
          {
            ...selectedProgram,
            snpEnabled: true,
          },
        ]);
      } else setCurriculumPrograms([]);
    }
  }, [isData, isLoading, data, curriculumProgramId]);

  const selectedProgram = _.first(curriculumPrograms);

  const handleToggleCurriculumProgramPermissions = () => {
    const currentSnpEnabled = _.get(selectedProgram, "snpEnabled", false);

    setCurriculumPrograms([
      {
        ...selectedProgram,
        snpEnabled: !currentSnpEnabled,
      },
    ]);
  };

  const getCurriculumProgramTypes = () => {
    const isSnpEnabled = _.get(selectedProgram, "snpEnabled", false);
    if (!isSnpEnabled) return [];
    return [_.get(selectedProgram, "uid")];
  };

  const handleClickSave = async (addedSet = [], removedSet = []) => {
    const permissions = getPermissionsPayloadForMutation(curriculumPrograms);

    const input = {
      apiType: ADD_ON_MANAGER,
      params: {
        organizationId,
        addOnType: AUTH_AND_EVAL,
        input: {
          permissions,
          addedSet,
          removedSet,
        },
      },
    };
    await updateSnpPermissions(input);
    onSuccessAddOnConfigChange();
  };

  return (
    <ManageSetsForSnP
      testId={localTestId}
      organizationId={organizationId}
      curriculumProgramTypes={getCurriculumProgramTypes()}
      onSubmit={handleClickSave}
      selectedProgram={selectedProgram}
      isQueryLoading={isLoading}
      handleToggleCurriculumProgramPermissions={
        handleToggleCurriculumProgramPermissions
      }
      onClose={closeModal}
    />
  );
};

const mapActionCreators = {
  updateSnpPermissions,
};

export default compose(
  connect(null, mapActionCreators),
  graphql(getInternalToolGenericDataQuery, {
    name: "getCurriculumProgramWithSnpPermissionStatus",
    options: ({ organizationId }) => ({
      variables: {
        input: {
          apiType: ADD_ON_MANAGER,
          params: {
            organizationId,
            addOnType: AUTH_AND_EVAL,
            queryType: FETCH_CURRICULUM_PROGRAM_WITH_SNP_PERM_STATUS,
          },
        },
      },
      fetchPolicy: "cache-and-network",
    }),
    props: ({ getCurriculumProgramWithSnpPermissionStatus }) => {
      const internalToolsGenericData = getInternalToolGenericDataFromCache(
        getCurriculumProgramWithSnpPermissionStatus.variables
      );

      const data = _.get(internalToolsGenericData, "data.curriculumPrograms");

      return {
        data,
        isData: !_.isEmpty(data),
        isLoading: _.includes(
          GRAPHQL_ONGOING_QUERY_NETWORK_STATUS,
          getCurriculumProgramWithSnpPermissionStatus.networkStatus
        ),
      };
    },
  }),
  withLoader
)(ManageAccessForSnP);
